import { render } from "./ItemPage.vue?vue&type=template&id=8ceb09cc&scoped=true"
const script = {}

import "./ItemPage.vue?vue&type=style&index=0&id=8ceb09cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ceb09cc"]])

export default __exports__